module.exports = __webpack_public_path__ + "media/custom-font-icon/icomoon-d970eb76.woff";